"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _node = babelHelpers.interopRequireDefault(require("./node"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _S3FileUploadControl = require("./S3FileUploadControl");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _Discussion = require("../Discussion");

var _class, _descriptor, _temp, _class3, _descriptor2, _descriptor3, _descriptor4, _temp2;

var VideoPendingBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(VideoPendingBody, _Component);

  function VideoPendingBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VideoPendingBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VideoPendingBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this.state = {
      uploadCallback: null
    };
    babelHelpers.initializerDefineProperty(_this, "commentPosted", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VideoPendingBody, [{
    key: "setUploadCallback",
    value: function setUploadCallback(callback) {
      this.setState({
        uploadCallback: callback
      });
    }
  }, {
    key: "doUpload",
    value: function doUpload() {
      var _this2 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this2.runUpload().then(function (result) {
          (0, _noty.showNotificationText)('Your video has been posted.');

          _this2.commentPosted();

          resolve(true);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: "runUpload",
    value: function runUpload() {
      var _this3 = this;

      var P = this.state.uploadCallback;
      return P().then(function (videoName) {
        return (0, _fetch.default)('data/discussion/post', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            child_type: 'video',
            parent: _this3.node.parent,
            comment: _this3.node.comment,
            video: videoName
          })
        });
      }).then(function (response) {
        if (response.ok) return response.status == 204 ? true : response.json();
        return response.json().then(function (value) {
          throw value;
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "comment"
      }, this.props.node.error ? _react.default.createElement("div", {
        className: "upload-pending error",
        ref: this.gotVideoInfoNode
      }, _react.default.createElement("div", {
        className: "name"
      }, this.props.node.video.split('/').pop()), false ? _react.default.createElement("div", null, _react.default.createElement(_S3FileUploadControl.S3FileUploadControl, {
        initialValue: null,
        setUploadCallback: this.setUploadCallback,
        generation: 1,
        accept: {
          extensions: ['3gp', 'avi', 'flv', 'm2ts', 'm4v', 'mp4', 'mpg', 'mpeg', 'mts', 'mov', 'wmv'],
          types: ['video/*']
        },
        buttonContent: "Select Video",
        buttonClass: "btn upload-btn",
        selectedButtonClass: "btn error-state selected-upload-btn"
      }), this.state.uploadCallback ? _react.default.createElement("button", {
        className: "btn upload-btn",
        onClick: this.doUpload
      }, "Upload") : null, null
      /* Help with uploading video? link here */
      ) : null) : _react.default.createElement("div", {
        className: "upload-pending",
        ref: this.gotVideoInfoNode
      }, _react.default.createElement("div", {
        className: "name"
      }, this.props.node.video.split('/').pop()), _react.default.createElement("div", {
        className: "upload-note"
      }, _react.default.createElement("p", null, "Your video has been submitted and queued for processing. Feel free to navigate away from this page as you wish. You will receive a notification when processing has been completed."))), _react.default.createElement("div", {
        className: "comment-text",
        style: {
          whiteSpace: 'pre-line'
        }
      }, this.props.children));
    }
  }, {
    key: "gotVideoInfoNode",
    value: function gotVideoInfoNode(node) {
      this.videoInfoNode = node;
      if (this.videoInfoNode) this.sizeElement();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      $(window).on('resize', this.sizeElement);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      $(window).off('resize', this.sizeElement);
    }
  }, {
    key: "sizeElement",
    value: function sizeElement() {
      if (this.videoInfoNode) {
        var w = this.videoInfoNode.offsetWidth;
        this.videoInfoNode.style.height = w * 9 / 16 + 'px';
      }
    }
  }]);
  return VideoPendingBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "setUploadCallback", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setUploadCallback"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doUpload", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doUpload"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotVideoInfoNode", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotVideoInfoNode"), _class.prototype)), _class);
var VideoPendingNode = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(VideoPendingNode, _Component2);

  function VideoPendingNode() {
    var _babelHelpers$getProt2;

    var _this4;

    babelHelpers.classCallCheck(this, VideoPendingNode);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this4 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(VideoPendingNode)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this4, "node", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "commentPosted", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    babelHelpers.initializerDefineProperty(_this4, "discussion", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this4)));
    _this4.state = {
      expanded: false,
      userProfile: null,
      submitting: false,
      mountedAt: Date.now()
    };
    return _this4;
  }

  babelHelpers.createClass(VideoPendingNode, [{
    key: "videoSubmittedNotification",
    value: function videoSubmittedNotification(event) {
      if (event.data.discussionRoot == this.node.node.parent) {
        this.commentPosted();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._Broadcaster = require('components/Notifications/Listener').default;

      this._Broadcaster.addEventListener('videoProcessed', this.videoSubmittedNotification);

      this._Broadcaster.addEventListener('updated-videoProcessed', this.videoSubmittedNotification);

      this._Broadcaster.addEventListener('removed-videoProcessed', this.videoSubmittedNotification);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._Broadcaster.removeEventListener('videoProcessed', this.videoSubmittedNotification);

      this._Broadcaster.removeEventListener('updated-videoProcessed', this.videoSubmittedNotification);

      this._Broadcaster.removeEventListener('removed-videoProcessed', this.videoSubmittedNotification);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (this.node) {
        return _react.default.createElement("div", {
          className: "comment-thread"
        }, _react.default.createElement(_node.default, {
          node: this.node.node,
          discussion: this.discussion,
          footer: null
        }, _react.default.createElement(VideoPendingBody, {
          commentPosted: this.commentPosted,
          node: this.node.node
        }, this.node.node.comment)), _react.default.createElement("section", {
          className: _classList.default.join('child-comments', this.state.expanded && 'open')
        }, _react.default.createElement("div", {
          className: "sub-comment-list"
        }, this.node.children.length ? this.node.children.map(function (child) {
          return _react.default.createElement(_Discussion.DiscussionNode, {
            discussion: _this5.discussion,
            key: child.node.id,
            commentPosted: _this5.commentPosted,
            node: child
          });
        }) : null)));
      }

      return null;
    }
  }]);
  return VideoPendingNode;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "videoSubmittedNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "videoSubmittedNotification"), _class3.prototype)), _class3);
exports.default = VideoPendingNode;